import { render } from "./InputVerifyCode.vue?vue&type=template&id=07e898d0&scoped=true"
import script from "./InputVerifyCode.vue?vue&type=script&lang=js"
export * from "./InputVerifyCode.vue?vue&type=script&lang=js"

import "./InputVerifyCode.vue?vue&type=style&index=0&id=07e898d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e898d0"]])

export default __exports__